// extracted by mini-css-extract-plugin
export default {"billDate":"PaymentTransactionHistory_billDate__CG36N","billDateText":"PaymentTransactionHistory_billDateText__BMJ-e","viewPDFButton":"PaymentTransactionHistory_viewPDFButton__NhGEL"};